export const LAYER_NAME = {
  CIRCLE_RADIUS: 'text-layer-area-radius',
  USERS_COUNT: 'text-layer-found-users-count-text',
  USERS_ICON: 'text-layer-found-users-count-icon',
  MEASURE_ICON: 'measurer-icon-layer'
} as const

export const LAYER_TEXT_COLOR: Record<
  'PRIMARY' | 'SELECTED',
  [number, number, number, number]
> = {
  PRIMARY: [8, 35, 35, 100],
  SELECTED: [8, 35, 35, 100]
}

export const MIN_PAINTER_SIZE = 100
export const MAX_PAINTER_SIZE = 250
